import {render} from "react-dom"
import React from "react"
import LeasePrice from "../../../src/components/site/show/LeasePrice"

window.addEventListener('DOMContentLoaded', () => {
  if (document.getElementById('leasePriceContainer') != null) {
    const itemId = extractItemId()
    const leasePrice = extractLeasePrice()

    render(
      <LeasePrice itemId={itemId} initialLeasePrice={leasePrice}/>,
      document.getElementById('leasePriceContainer')
    )
  }
})

function extractItemId() {
  const leasePriceDom = document.getElementById('leasePriceContainer')
  return leasePriceDom.getAttribute('item_id')
}

function extractLeasePrice() {
  const leasePriceDom = document.getElementById('leasePriceContainer')
  return leasePriceDom.getAttribute('lease_price')
}
